// Globals
import { useEffect } from 'react';

// Store
import { useAppDispatch, useAppState } from '@/store';

// Modules
import { selectProperty, updatePropertyProgress } from '@/modules/Properties';

// Components
import { Spinner } from '@/ui';
import AppraiserProgressContainer from '../AppraiserProgressContainer/AppraiserProgressContainer';
import DocumentsProgressContainer from '../DocumentsProgressContainer/DocumentsProgressContainer';
import GeneralInformationContainer from '../GeneralInformationContainer/GeneralInformationContainer';
import PhotoshootingProgressContainer from '../PhotoshootingProgressContainer/PhotoshootingProgressContainer';
import ContractProgressContainer from '../ContractProgressContainer/ContractProgressContainer';
import ViewingProgressContainer from '../ViewingProgressContainer/ViewingProgressContainer';
import AdProgressContainer from '../AdProgressContainer/AdProgressContainer';
import SettlementProgressContainer from '../SettlementProgressContainer/SettlementProgressContainer';
import BiddingProgressContainer from '../BiddingProgressContainer/BiddingProgressContainer';
import { StyledContainer } from './PropertyProgressContainerStyles';

// Helpers
import { getEntityId } from '@/utils';
import { useGetPropertyProgress } from '../../hooks';

type TPropertyProgressContainerProps = {
  hideResetButton?: boolean;
};

const PropertyProgressContainer = ({ hideResetButton = false }: TPropertyProgressContainerProps) => {
  const property = useAppState(selectProperty);
  const { isLoading, progress } = useGetPropertyProgress(getEntityId(property?.PK ?? ''));
  const dispatch = useAppDispatch();

  useEffect(() => {
    if (!property?.PK || !progress) return;
    dispatch(updatePropertyProgress({ PK: property.PK, progress }));
  }, [property?.PK, progress]);

  return (
    <div>
      <Spinner spinning={isLoading}>
        <GeneralInformationContainer />
        <StyledContainer>
          <AppraiserProgressContainer hideResetButton={hideResetButton} />
          <PhotoshootingProgressContainer hideResetButton={hideResetButton} />
          <DocumentsProgressContainer hideResetButton={hideResetButton} />
          <AdProgressContainer hideResetButton={hideResetButton} />
          <ViewingProgressContainer hideResetButton={hideResetButton} />
          <BiddingProgressContainer hideResetButton={hideResetButton} />
          <ContractProgressContainer hideResetButton={hideResetButton} />
          <SettlementProgressContainer hideResetButton={hideResetButton} />
        </StyledContainer>
      </Spinner>
    </div>
  );
};

export default PropertyProgressContainer;
